export default __webpack_public_path__ + "static/media/prysmatic-bg.25c40ad5.png";